import { useSyncExternalStore } from "react";
import { MdWarningAmber } from "react-icons/md";
import {
  confirmarAlertasCiencia,
  inscreverAlertasCiencia,
  obterAlertasCiencia,
} from "utils/alertaCiencia";
import * as S from "./styles";

/**
 * Exibe os avisos que exigem ciência do usuário. Diferente do toast, só sai da
 * tela quando o usuário confirma, então o aviso não passa despercebido.
 */
export default function AlertaCienciaModal() {
  const alertas = useSyncExternalStore(
    inscreverAlertasCiencia,
    obterAlertasCiencia
  );

  if (alertas.length === 0) return null;

  return (
    <S.Overlay role="alertdialog" aria-modal="true" aria-label="Atenção">
      <S.Card>
        <S.IconWrapper>
          <S.IconCircle>
            <MdWarningAmber size={28} />
          </S.IconCircle>
        </S.IconWrapper>
        <S.Messages>
          {alertas.map((alerta) => (
            <S.Text key={`${alerta?.titulo}-${alerta?.mensagem}`}>
              {alerta?.titulo ? <strong>{alerta.titulo}:</strong> : null}{" "}
              {alerta?.mensagem}
            </S.Text>
          ))}
        </S.Messages>
        <S.Button type="button" autoFocus onClick={confirmarAlertasCiencia}>
          Entendi
        </S.Button>
      </S.Card>
    </S.Overlay>
  );
}
